/******/ (() => { // webpackBootstrap
/*!************************************!*\
  !*** ./src/js/sections/headers.js ***!
  \************************************/
// Add the correct sticky class when the header is pinned to the top.
const el = document.querySelector('#sticky-detector');
const observer = new IntersectionObserver(([e]) => {
  const $mainHeader = document.querySelector('[id*="shopify-section-header"]');
  $mainHeader.classList.toggle('is-sticky', e.intersectionRatio < 1);
}, {
  rootMargin: '0px 0px 0px 0px',
  threshold: [1]
});
observer.observe(el);
const $announcementBar = document.querySelector('.announcement-bar');
const $mainHeader = document.querySelector('[id*="shopify-section-header"]');
var headerResizeObserver = new ResizeObserver(entries => {
  entries.forEach(element => {
    const height = element.borderBoxSize[0].blockSize;
    const headerBottomScrollPosition = element.target.getBoundingClientRect().bottom;
    if (element.target === $mainHeader) {
      document.documentElement.style.setProperty('--header-scroll-position', headerBottomScrollPosition + 'px');
      document.documentElement.style.setProperty('--header-height', height + 'px');
    }
    if (element.target === $announcementBar) {
      document.documentElement.style.setProperty('--announcement-height', height + 'px');
    }
  });
});
function calculateHeaderHeight() {
  var $header = document.querySelector('[id*="shopify-section-header"] header');
  var height = $header.getBoundingClientRect().bottom;
  if (height < 0) {
    height = 0;
  }
  document.documentElement.style.setProperty('--header-scroll-position', height + 'px');
}
window.addEventListener('scroll', function () {
  setTimeout(function () {
    calculateHeaderHeight();
  }, 100);
});
if ($announcementBar) {
  headerResizeObserver.observe($announcementBar);
} else {
  document.documentElement.style.setProperty('--announcement-height', 0 + 'px');
}
if ($mainHeader) {
  headerResizeObserver.observe($mainHeader);
} else {
  document.documentElement.style.setProperty('--header-height', 0 + 'px');
}
/******/ })()
;